export const formatDate = (dateString: string, locale: string) => {
  if (!dateString) return '';

  const date = new Date(dateString);

  // 한국(KO) 처리
  if (locale === 'ko') {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}.${month}.${day}`;
  }

  // 그 외 locale 처리
  const day = date.toLocaleString(locale, { day: '2-digit' });
  const month = date.toLocaleString(locale, { month: 'short' });
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};
